import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const navLinks = [{
    name: 'El Problema',
    href: '#el-problema'
  }, {
    name: 'El Sistema',
    href: '#el-sistema'
  }, {
    name: 'Sobre mí',
    href: '#sobre-mi'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/5" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="flex items-center justify-between h-20 gap-4" data-id="element-94">
          {/* Logo */}
          <div className="flex-shrink-0 min-w-0" data-id="element-95">
            <a href="#" className="flex flex-col" data-id="element-96">
              <span className="font-heading font-bold text-base sm:text-xl text-white tracking-tight truncate" data-id="element-97">
                Joaquín González Paredes
              </span>
              <span className="text-accent text-[10px] sm:text-xs font-medium tracking-wider uppercase mt-0.5" data-id="element-98">
                Sistema de Demanda Sostenida
              </span>
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block" data-id="element-99">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-100">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-accent transition-colors duration-300 px-3 py-2 rounded-md text-sm font-medium" data-id="element-101">
                  {link.name}
                </a>)}
            </div>
          </div>

          {/* CTA */}
          <div className="flex-shrink-0" data-id="element-102">
            <a href="#agendar" className="inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-2.5 border border-transparent text-xs sm:text-sm font-bold rounded-lg text-white bg-accent glow-button" data-id="element-103">
              Agendar
            </a>
          </div>
        </div>
      </div>
    </nav>;
}